import { render, staticRenderFns } from "./AltLogin.vue?vue&type=template&id=5f35350a&scoped=true&"
import script from "./AltLogin.vue?vue&type=script&lang=js&"
export * from "./AltLogin.vue?vue&type=script&lang=js&"
import style0 from "./AltLogin.vue?vue&type=style&index=0&id=5f35350a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35350a",
  null
  
)

export default component.exports